import { render, staticRenderFns } from "./updateCommAffiliate.vue?vue&type=template&id=5bb358a8&lang=pug"
import script from "./updateCommAffiliate.vue?vue&type=script&lang=js"
export * from "./updateCommAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports